import { AimOutlined, CloseCircleFilled } from '@ant-design/icons';
import classNames from 'classnames';

import styles from './index.module.scss';

export type ClearAllNumberRangeInputProps = {
  allowClear?: boolean;
  isValueDefined: boolean;
  onClick: () => void;
};

export const ClearAllNumberRangeInput = ({
  allowClear,
  onClick,
  isValueDefined,
}: ClearAllNumberRangeInputProps) => {
  if (!allowClear || !isValueDefined) {
    return (
      <div className={styles.clearAllContainer}>
        <AimOutlined className={styles.clearAllAlternativeIcon} />
      </div>
    );
  }

  return (
    <div className={styles.clearAllContainer}>
      <CloseCircleFilled
        type="text"
        className={classNames(styles.clearAll)}
        onClick={() => onClick()}
      />
      <AimOutlined
        className={classNames(
          styles.clearAllAlternativeIcon,
          isValueDefined ? styles.clearAllAlternativeIconHide : null,
        )}
      />
    </div>
  );
};
